import React, {useEffect, useRef, useState} from 'react';
import {embedDashboard} from 'amazon-quicksight-embedding-sdk';
import {isEqual} from 'lodash';

const DashboardView = ({dashUrl, parameters, idDash, retrieveSheets, selectedSheetChanged, selected}) => {
    const [dashBoard, setdashBoard] = useState();
    const [isLoaded, setisLoaded] = useState(false);
    const [isBuild, setisBuild] = useState(false);
    const divContainer = useRef(null);
    const [selectedSheet, setSelectedSheet] = useState();
    const [parametersSent, setparametersSent] = useState();

    useEffect(() => {
        if (!isBuild && dashUrl && parameters && divContainer) {
            // setdashBoard(embedDashboard(options));
            const options = {
                url: dashUrl,
                container: `#${idDash}`,
                parameters,
                scrolling: 'no',
                // height: "700px",
                iframeResizeOnSheetChange: false,
                height: 'AutoFit',
                loadingHeight: '700px',
                // width: "1000px",
                locale: 'it-IT', // use this option to specify initial sheet id to load for the embedded dashboard
                sheetTabsDisabled: true, // use this option to enable or disable sheet tab controls in dashboard embedding

                // footerPaddingEnabled: true,
                // sheetId: 'YOUR_SHEETID' // use this option to specify initial sheet id to load for the embedded dashboard
                // sheetTabsDisabled: false, // use this option to enable or disable sheet tab controls in dashboard embedding
                printEnabled: true, // use this option to enable or disable print option for dashboard embedding
                // defaultEmbeddingVisualType: TABLE // this option only applies to experience embedding and will not be used for dashboard embedding
            };
            const dashboardloader = embedDashboard(options);
            setdashBoard(dashboardloader);
            setisBuild(true);
            setparametersSent(parameters);
        }
        return;
    }, [dashUrl, parameters, divContainer, idDash, isBuild]);

    useEffect(() => {
        dashBoard &&
      dashBoard.on('load', () => {
          setisLoaded(true);
          dashBoard.getSheets((sheetsData) => {
              sheetsData && sheetsData.sheets[0] && setSelectedSheet(sheetsData.sheets[0].sheetId);
              retrieveSheets(sheetsData.sheets);
          });
      });
        dashBoard && dashBoard.on('error', (err) => console.log('Dash Error', err));
    }, [dashBoard, retrieveSheets]);

    useEffect(() => {
        if (selected && dashBoard && selectedSheet && selectedSheetChanged) {
            dashBoard.navigateToSheet(selectedSheetChanged);
            setSelectedSheet(selectedSheetChanged);
        }
    }, [dashBoard, selectedSheet, selectedSheetChanged, selected]);

    useEffect(() => {
        if (dashBoard && isLoaded && !isEqual(parametersSent, parameters)) {
            setparametersSent(parameters);
            dashBoard.setParameters(parameters);
        }
    }, [dashBoard, parameters, isLoaded, parametersSent]);

    return <div ref={divContainer} id={idDash} />;
};
export default React.memo(DashboardView);
